import { ConfigService, getConfigService } from 'src/services/ConfigService';

import { AccountApplicationApi } from './AccountApplicationApi';
import { AccountHoldersApi } from './AccountHoldersApi';
import { AccountsApi } from './AccountsApi';
import { AchRelationshipsApi } from './AchRelationshipsApi';
import { BalanceApi } from './BalanceApi';
import { ConfigsApi } from './ConfigsApi';
import { FileExportApi } from './FileExportApi';
import { InvestigationsApi } from './InvestigationsApi';
import { LegacyUserApi } from './LegacyUserApi';
import { OfferDocumentsApi } from './OfferDocumentsApi';
import { OfferOptionsApi } from './OfferOptionsApi';
import { OfferOrdersApi } from './OfferOrdersApi';
import { OfferOversubscriptionApi } from './OfferOversubscriptionApi';
import { OffersApi } from './OffersApi';
import { OfferWatchesApi } from './OfferWatchesApi';
import { OrdersApi } from './OrdersApi';
import { PrivateQuotesApi } from './PrivateQuotesApi';
import { SnapQuotesApi } from './SnapQuotesApi';
import { TransfersApi } from './TransfersApi';
import { UsersApi } from './UsersApi';

export class ClientApi {
  accountApplication: AccountApplicationApi;
  users: UsersApi;
  legacyUser: LegacyUserApi;
  investigations: InvestigationsApi;
  accounts: AccountsApi;
  accountHolders: AccountHoldersApi;
  balance: BalanceApi;
  offers: OffersApi;
  privateQuotes: PrivateQuotesApi;
  snapQuotes: SnapQuotesApi;
  configs: ConfigsApi;
  offerOrders: OfferOrdersApi;
  offerOptions: OfferOptionsApi;
  offerDocuments: OfferDocumentsApi;
  offerOversubscription: OfferOversubscriptionApi;
  offerWatches: OfferWatchesApi;
  orders: OrdersApi;
  transfers: TransfersApi;
  achRelationships: AchRelationshipsApi;
  fileExport: FileExportApi;

  constructor(configService: ConfigService) {
    this.accountApplication = new AccountApplicationApi(configService);
    this.users = new UsersApi(configService);
    this.legacyUser = new LegacyUserApi(configService);
    this.investigations = new InvestigationsApi(configService);
    this.accounts = new AccountsApi(configService);
    this.accountHolders = new AccountHoldersApi(configService);
    this.balance = new BalanceApi(configService);
    this.offers = new OffersApi(configService);
    this.privateQuotes = new PrivateQuotesApi(configService);
    this.snapQuotes = new SnapQuotesApi(configService);
    this.configs = new ConfigsApi(configService);
    this.offerOrders = new OfferOrdersApi(configService);
    this.offerOptions = new OfferOptionsApi(configService);
    this.offerDocuments = new OfferDocumentsApi(configService);
    this.offerOversubscription = new OfferOversubscriptionApi(configService);
    this.offerWatches = new OfferWatchesApi(configService);
    this.orders = new OrdersApi(configService);
    this.transfers = new TransfersApi(configService);
    this.achRelationships = new AchRelationshipsApi(configService);
    this.fileExport = new FileExportApi(configService);
  }
}

const clientApi = new ClientApi(getConfigService());

export const getClientApi = () => {
  return clientApi;
};
